import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { FormattedMessage } from "react-intl"
import { StringColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"

export default (columnDefinition: StringColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const value = info.getValue() as string

        if (value) {
            if (columnDefinition.dataAttributes?.messageMap) {
                const message = columnDefinition.dataAttributes.messageMap[value]
                return message
                    ? <FormattedMessage {...message} />
                    : value
            } else {
                return value
            }
        } else {
            return columnDefinition.dataAttributes?.defaultValue || "-"
        }
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/StringCellMapper.tsx